module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-he.1ee9121f.png";